export const DialogTypes = {
  CASE: "case"
};
